import { TermsAndConditions } from "../components/terms-and-conditions";
import { Layout } from "../containers";

const TermsAndConditionsPage = () => {
  return (
    <Layout className="bg-neutral-100">
      <TermsAndConditions />
    </Layout>
  );
};

export default TermsAndConditionsPage;
